import { OverlayScrollbars } from 'overlayscrollbars'; //? https://kingsora.github.io/OverlayScrollbars/ 


const shopFilter = document.querySelector(".shop-filters")
if(shopFilter){
    initShopFilters()

    // Add custom scroll bar to the filters when needed
    OverlayScrollbars(document.querySelector('#quickViewModal .modal-body'), {
        overflow: {
            x: 'hidden',
        },
        scrollbars: {
            visibility: 'auto',
            autoHide: 'leave',
        }
    });     
}

function initShopFilters(){

    // Add custom scroll bar to the filters when needed
    OverlayScrollbars(document.querySelector('.filters-body'), {
        overflow: {
            x: 'hidden',
        },
        scrollbars: {
            visibility: 'auto',
            autoHide: 'leave',
        }
    }); 

    // Resize sticky filter button when it becomes sticky
    window.onscroll = function() { 
        const el = document.querySelector(".filter-col")
        const observer = new IntersectionObserver( 
            ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
            { threshold: [1] }
        );

        observer.observe(el);
    }

        
    // Open and close filters on mobile devices
    window.addEventListener('load', (event) => {

        // Set variables
        var body = document.querySelector("body");
        var filters = document.querySelector(".shop-filters");
        var button = document.querySelector('.product-filters-button');
        var closeButton = document.querySelector('.close-filters-button');
        var windowWidth = document.body.clientWidth;


        // Toggle menu function
        var toggleDrawer = function(){
            body.classList.toggle('filters-open');
            button.classList.toggle('toggled');
            document.documentElement.classList.toggle('no-scroll');
        }

        if(button){

            // Open/close filters using button
            button.addEventListener("click",function(event){
                event.stopPropagation();
                toggleDrawer();
            }, false); 

            // Prevent filters from closing when clicked
            filters.addEventListener("click",function(event){
                event.stopPropagation();
            }, false);         

            // Close filters when clicking off them
            body.addEventListener("click",function(){
                if (body.classList.contains('filters-open')) {
                    toggleDrawer();
                }
            }, false);    
            
            // Close filters when clicking close button
            closeButton.addEventListener("click",function(){
                if (body.classList.contains('filters-open')) {
                    toggleDrawer();
                }
            }, false);          

            // Close filters if window is resized
            window.addEventListener("resize",function(){
                if(document.body.clientWidth !== windowWidth){
                    if (body.classList.contains('filters-open')) {
                        toggleDrawer();
                    }
                }
                windowWidth = document.body.clientWidth;
            });

        }
    }); 


}



const quickviewModal = document.querySelector("#quickViewModal")
if(quickviewModal){

    // Add custom scroll bar to the modal when needed
    OverlayScrollbars(document.querySelector('#quickViewModal .modal-body'), {
        overflow: {
            x: 'hidden',
        },
        scrollbars: {
            visibility: 'auto',
            autoHide: 'leave',
        }
    });     
}

